export { DetailPageHeaderTemplate } from './DetailPageTemplate'
export type { DetailPageHeaderTemplateProps } from './DetailPageTemplate.types'
